{
  "appName": "Al-Musafer Fuel",
  "brand": "المسافر",
  "platform": "المنصة",
  "actions": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "create": "إضافة",
    "search": "بحث",
    "retry": "تحديث",
    "close": "إغلاق",
    "confirm": "تأكيد",
    "apply": "تطبيق",
    "reset": "إعادة تعيين",
    "rotate": "تدوير",
    "view": "عرض",
    "expandAll": "توسيع الكل",
    "collapseAll": "طي الكل",
    "addItem": "إضافة عنصر",
    "export": "تصدير إلى Excel",
    "exporting": "تصدير..."
  },
  "yes": "نعم",
  "no": "لا",
  "nav": {
    "dashboard": "لوحة التحكم",
    "users": "المستخدمون",
    "settings": "الإعدادات",
    "logout": "تسجيل الخروج"
  },
  "language": {
    "label": "اللغة",
    "ar": "العربية",
    "en": "English",
    "switchTo": {
      "ar": "التبديل إلى العربية",
      "en": "التبديل إلى الإنجليزية"
    }
  },
  "theme": {
    "switchToLight": "التبديل إلى الوضع الفاتح",
    "switchToDark": "التبديل إلى الوضع الداكن"
  },
  "preferences": {
    "label": "إعدادات اللغة والمظهر"
  },
  "state": {
    "loading": "جاري التحميل...",
    "empty": "لا توجد بيانات",
    "error": "تعذر تحميل البيانات",
    "notBuilt": "قيد الإنشاء"
  },
  "accessDenied": {
    "title": "تم رفض الوصول",
    "description": "ليس لديك صلاحية لعرض هذه الصفحة"
  },
  "list": {
    "noResultsTitle": "لا توجد نتائج",
    "noDataTitle": "لا توجد بيانات متاحة",
    "showingRange": "عرض {{start}}-{{end}} من {{total}}"
  },
  "drawer": {
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "سيتم فقدان التغييرات غير المحفوظة. هل تريد المتابعة؟",
    "discardConfirm": "تجاهل",
    "discardCancel": "متابعة التعديل"
  },
  "filters": {
    "allBranches": "جميع الفروع",
    "branch": "الفرع",
    "fromDate": "من تاريخ",
    "toDate": "إلى تاريخ"
  },
  "filterToolbar": {
    "phoneCountryCode": "رمز الدولة",
    "toggle": "الفلاتر",
    "resetFilters": "إعادة تعيين الفلاتر"
  },
  "combobox": {
    "placeholder": "اختر...",
    "search": "بحث...",
    "empty": "لا توجد نتائج",
    "clearOption": "بدون",
    "clearSelection": "مسح التحديد",
    "removeSelection": "إزالة {{label}}",
    "selectedCount_one": "تم اختيار {{count}} عنصر",
    "selectedCount_two": "تم اختيار {{count}} عنصر",
    "selectedCount_few": "تم اختيار {{count}} عناصر",
    "selectedCount_many": "تم اختيار {{count}} عنصر",
    "selectedCount_other": "تم اختيار {{count}} عنصر",
    "options": "الخيارات"
  },
  "pagination": {
    "page": "صفحة {{page}} من {{totalPages}}",
    "total": "{{total}} سجل",
    "next": "التالي",
    "previous": "السابق",
    "label": "التنقل بين الصفحات",
    "morePages": "صفحات أخرى"
  },
  "search": {
    "noResults": "لا نتائج مطابقة للبحث",
    "placeholder": "بحث..."
  },
  "identity": {
    "nameNotProvided": "لا يوجد اسم"
  },
  "selectItem": {
    "placeholder": "اختر عنصرا...",
    "selected": "عنصر محدد"
  },
  "multiselect": {
    "selectSomeItems": "اختر عناصر"
  },
  "media": {
    "imageViewer": "عارض الصور",
    "viewLarger": "عرض بحجم أكبر",
    "editImage": "تعديل الصورة",
    "cropAndAdjust": "قص الصورة وضبطها",
    "zoom": "التكبير",
    "zoomIn": "تكبير",
    "zoomOut": "تصغير",
    "rotation": "التدوير",
    "cameraCapture": "التقاط بالكاميرا",
    "positionInFrame": "ضع نفسك داخل الإطار",
    "takePhoto": "التقاط صورة",
    "uploadFile": "رفع ملف",
    "uploaded": "تم الرفع",
    "dragDropImage": "اسحب صورة وأفلتها هنا",
    "selectedLabel": "المحدد",
    "deleteTitle": "حذف {{name}}؟",
    "deleteMessage": "ستتم إزالة {{name}}. لا يمكن التراجع عن هذا الإجراء."
  },
  "treeDemo": {
    "title": "مستعرض الملفات",
    "searchPlaceholder": "البحث في الملفات",
    "reports": "التقارير",
    "salesReport": "تقرير المبيعات",
    "inventoryReport": "تقرير المخزون",
    "documents": "المستندات",
    "invoiceTemplate": "نموذج فاتورة",
    "configurations": "الإعدادات"
  },
  "table": {
    "resetFilters": "إعادة تعيين الفلاتر",
    "clearFilter": "إزالة الفلتر: {{label}}",
    "sortBy": "الفرز حسب {{column}}",
    "sortedAscending": "ترتيب تصاعدي",
    "sortedDescending": "ترتيب تنازلي",
    "selectRow": "تحديد الصف",
    "selectAllRows": "تحديد كل الصفوف",
    "selectPage": "تحديد كل عناصر هذه الصفحة",
    "selectAllMatching": "تحديد كل {{count}} عنصر مطابق",
    "selectedCount": "تم تحديد {{count}}",
    "clearSelection": "إلغاء التحديد",
    "permissionDeniedTitle": "لا يمكنك عرض هذه البيانات",
    "permissionDeniedDescription": "ليس لديك صلاحية لعرض هذه البيانات.",
    "initialEmptyTitle": "لا توجد سجلات بعد",
    "filteredEmptyDescription": "جرب بحثا مختلفا أو عدل الفلاتر.",
    "errorDescription": "أعد المحاولة أو تواصل مع المسؤول إذا استمرت المشكلة.",
    "partialTitle": "تعذر تحميل بعض البيانات",
    "loading": "جاري تحميل السجلات",
    "pageSizeLabel": "عدد الصفوف بالصفحة",
    "moreActions": "المزيد من الإجراءات",
    "actions": "الإجراءات",
    "rowActionsLabel": "إجراءات {{name}}"
  },
  "archive": {
    "banner": "أرشيف — للقراءة فقط"
  },
  "password": {
    "show": "إظهار كلمة المرور",
    "hide": "إخفاء كلمة المرور"
  },
  "breadcrumb": {
    "label": "مسار التنقل",
    "more": "المزيد"
  },
  "toaster": {
    "label": "الإشعارات"
  },
  "phoneLink": {
    "phoneTaken": "رفض نظام العملاء هذا الرقم، عدل رقم الهاتف",
    "receiptExpired": "انتهت صلاحية تأكيد الرقم، أعد التحقق",
    "reverify": "إعادة التحقق",
    "takenBy": "رقم الهاتف مسجل للعميل {{name}}",
    "viewCustomer": "عرض العميل",
    "refused": "رفض نظام العملاء الربط، راجع بيانات العميل"
  }
}
